import React, { useEffect } from 'react'
import { BackHandler, TouchableOpacity, Platform } from 'react-native'
import { COMMON_STYLES } from '@dehaat/dds'
import { navigationRef } from 'app/utils/RootNavigation'
import { defaultBackPressCallback } from 'app/utils/common'
import BackCaret from 'app/icons/BackCaret'

interface Props {
  onBackPress?: () => boolean
  dependency?: string
}

const hasBrowserHistory = () =>
  typeof window !== 'undefined' && window.history && window.history.length > 1

const CustomBackButton = ({ onBackPress, dependency = '' }: Props) => {
  const hideBackButton =
    Platform.OS === 'web' &&
    !navigationRef.canGoBack() &&
    !hasBrowserHistory()
  useEffect(() => {
    if (Platform.OS === 'android') {
      BackHandler.addEventListener(
        'hardwareBackPress',
        onBackPress || defaultBackPressCallback,
      )
    }
    return () => {
      if (Platform.OS === 'android') {
        BackHandler.removeEventListener(
          'hardwareBackPress',
          onBackPress || defaultBackPressCallback,
        )
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dependency])

  if (hideBackButton) {
    return <></>
  }
  return (
    <TouchableOpacity
      onPress={onBackPress || defaultBackPressCallback}
      style={COMMON_STYLES['ph1/2']}
    >
      <BackCaret
        height={24}
        width={24}
        strokeWidth={2}
        style={COMMON_STYLES['mr0.5']}
      />
    </TouchableOpacity>
  )
}

export default CustomBackButton
